export enum CAR_MODELS{
  TERRITORY = 'TERRITORY',
  RANGER = 'RANGER',
  // Add more car models as needed
}
